"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _server = require("b2b-components/utils/server");
var _classnames = _interopRequireDefault(require("classnames"));
var _Tooltip = require("../../Tooltip");
require("./CopyButton.scss");
var CopyButton = function CopyButton(_ref) {
  var buttonSize = _ref.buttonSize,
    className = _ref.className,
    iconName = _ref.iconName,
    isCopyButtonVisible = _ref.isCopyButtonVisible,
    isTooltipEnabled = _ref.isTooltipEnabled,
    isTooltipVisible = _ref.isTooltipVisible,
    onCopy = _ref.onCopy,
    onMouseLeave = _ref.onMouseLeave,
    onMouseEnter = _ref.onMouseEnter,
    onTransitionEnd = _ref.onTransitionEnd,
    tooltipAnchorRef = _ref.tooltipAnchorRef,
    tooltipPosition = _ref.tooltipPosition,
    tooltipRef = _ref.tooltipRef,
    tooltipText = _ref.tooltipText;
  var body = !_server.isServer ? document.body : undefined;
  var buttonIconClassName = (0, _classnames["default"])('cds-CopyableText-CopyButton', {
    'cds-CopyableText-CopyButton--Visible': isCopyButtonVisible
  });
  var Portal = function Portal() {
    return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
      position: tooltipPosition,
      tooltipRef: tooltipRef
    }, tooltipText), body);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: tooltipAnchorRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(buttonIconClassName, className),
    onTransitionEnd: onTransitionEnd
  }, /*#__PURE__*/_react["default"].createElement(_ButtonIcon.ButtonIcon, {
    icon: iconName,
    styleType: _ButtonIcon.BUTTON_ICON_STYLE_TYPE.blank,
    size: buttonSize,
    onClick: onCopy
  })), isTooltipEnabled && isTooltipVisible && /*#__PURE__*/_react["default"].createElement(Portal, null));
};
exports.CopyButton = CopyButton;